var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFacebookIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 20,
    viewBox: "0 0 10 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.64805 4.67363C5.64805 3.90918 6.33086 3.63457 7.09531 3.63457C7.85977 3.63457 8.67617 3.87207 8.67617 3.87207L9.16602 0.962694C9.16602 0.962694 8.12695 0.606445 5.64805 0.606445C4.12656 0.606445 3.24336 1.18535 2.59766 2.03887C1.98906 2.84785 1.9668 4.14668 1.9668 4.98535V6.89277H0V9.73535H1.9668V19.6064H5.64805V9.73535H8.56484L8.78008 6.89277H5.64805V4.67363Z",
    fill: ""
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacebookIcon);
export default __webpack_public_path__ + "static/media/facebook-icon.8a22988afb2219ba4757260a6af6dab2.svg";
export { ForwardRef as ReactComponent };